export const createAction = (type) => (items) => ({
    type,
    payload: items
});
